import { Component } from '@angular/core';
import { AdminSettings } from 'src/app/enums/settings';
import { PermissionsService } from 'src/app/services/permissions.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-admin-setari',
    templateUrl: './admin-setari.component.html',
    styleUrls: ['./admin-setari.component.scss'],
})
export class AdminSetariComponent {
    readonly AdminSettings = AdminSettings;
    selectedComponent!: AdminSettings;

    componentMapping: Record<AdminSettings, string> = {
        [AdminSettings.CONFIGURARI]: 'app-configurari',
        [AdminSettings.STORAGE_LOCATIONS]: 'app-storage-locations',
        [AdminSettings.CRON]: 'app-cron',
        [AdminSettings.SIGNER]: 'app-sign-settings-configuration',
        [AdminSettings.SIGNING_LOGS]: 'app-signing-logs',
        [AdminSettings.AUDIT_LOGS]: 'app-audit-logs',
        [AdminSettings.AUDIT_ARCHIVES]: 'app-audit-archives'
    };

    componentKeys: string[] = Object.keys(this.componentMapping);
    onChange($event: { value: any }) {
        this.selectedComponent = $event.value;
    }

    selectedSection: any = null;

    constructor(private permissionsService: PermissionsService) {
        this.filterComponents();
    }

    filterComponents() {
        if (!this.permissionsService.hasPermission('indoc-module.administrative.configurations.list')) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== AdminSettings.CONFIGURARI
            );
        }

        if (!this.permissionsService.hasPermission('indoc-module.administrative.storage-locations.list')) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== AdminSettings.STORAGE_LOCATIONS
            );
        }

        if (!this.permissionsService.hasPermission('indoc-module.administrative.crons.list')) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== AdminSettings.CRON
            );
        }

        if (!this.permissionsService.hasPermission('indoc-module.administrative.signer.list')) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== AdminSettings.SIGNER
            );
        }

        // Signing Logs, Audit Logs, and Audit Archives - only for admin users
        const isAdmin = this.checkUserTypeAdmin();
        if (!isAdmin) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== AdminSettings.SIGNING_LOGS &&
                          item !== AdminSettings.AUDIT_LOGS &&
                          item !== AdminSettings.AUDIT_ARCHIVES
            );
        }
    }

    private checkUserTypeAdmin(): boolean {
        try {
            const userKey = environment.config.userKey;
            const userDataStr = localStorage.getItem(userKey);
            if (userDataStr) {
                let userData = JSON.parse(userDataStr);
                if (typeof userData === 'string') {
                    userData = JSON.parse(userData);
                }
                return userData?.user_type === 'admin';
            }
        } catch (e) {
            console.error('Error checking user type:', e);
        }
        return false;
    }
}
